export default __webpack_public_path__ + "649137aeeb806b93b83374ba5bc35b84.png";